import useSWR from 'swr';
import letrusAPI from 'APIs/letrusAPI/axiosInstance';
import {GetParams} from '@letrustech/letrus-api-interfaces/dist/utils/get_params';
import {NotificationListResponse} from './types';

export function fetchNotificationRequest(params?: GetParams) {
  return useSWR<NotificationListResponse>(
    ['/api/v1/notification_logs/', params],
    (key) => {
      const [url, reqParams] = key;
      return letrusAPI(url, {
        params: {
          ...(reqParams ?? {}),
          channel: 'web',
          created__year: new Date().getFullYear(),
        },
      }).then((res) => res.data);
    },
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    },
  );
}

export async function updateNotificationById(notificationId, notificationData) {
  return letrusAPI(`/api/v1/notification_logs/${notificationId}/`, {
    method: 'patch',
    data: notificationData,
  }).then((res) => res.data);
}
